import { useQuery, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useState,useEffect,useLayoutEffect} from 'react';
import styled from 'styled-components';
import { fetchFromAPI } from '../utils';
import ComboBox from '../components/atoms/comboBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronUp, faChevronDown} from '@fortawesome/free-solid-svg-icons';
import Button from "../components/atoms/button";



const queryClient = new QueryClient()

export default function MMMWidget() {
  const [selectedModel, setSelectedModel] = useState('');
  const [selectedMachine, setSelectedMachine] = useState('');
  const [selectedMake, setSelectedMake] = useState('');
  const [facetFilters, setFacetFilters] = useState([]);
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    setSelectedModel(searchParams.get('model')||'')
    setSelectedMachine(searchParams.get('machine')||'')
    setSelectedMake(searchParams.get('make')|| '')
  },[]);

  useEffect(()=>{
    const filters = [];
    if (selectedMake) {
      filters.push(`Make:"${selectedMake}"`);
    }
    if (selectedModel) {
      filters.push(`Model:"${selectedModel}"`);
    }
    if (selectedMachine) {
      filters.push(`Machine:"${selectedMachine}"`);
    }
    setFacetFilters(filters);
  }, [selectedMake, selectedModel, selectedMachine]);

const handleMakeChange=(make)=>{
  setSelectedMake(make)
  setSelectedMachine("")
  setSelectedModel("")
 }

const handleMachineChange=(machine)=>{
  setSelectedMachine(machine)
  setSelectedModel("")
 }

const handleModelChange=(model)=>{
  setSelectedModel(model)
 }
    
const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href=`/search-by-make-machine-model-ag-construction-turf-equipment-seats-and-parts?make=${encodeURIComponent(selectedMake)}&machine=${encodeURIComponent(selectedMachine)}&model=${encodeURIComponent(selectedModel)}`


  };


  useLayoutEffect(() => {
  const mediaQueryList = window.matchMedia('(max-width: 1024px)');
  const handleMediaChange = (e) => {
    if(e.matches){
      setIsExpanded(false)
    }else{
      setIsExpanded(true)
    }
  };
  if(mediaQueryList.matches){
    setIsExpanded(true)
  } 
  mediaQueryList.addEventListener('change', handleMediaChange);
  return ()=>{
    mediaQueryList.removeEventListener('change', handleMediaChange);
  }
}, []);
 
  return (
      <QueryClientProvider client={queryClient}>
        <div className="mmm-widget">
        <StyledContainer onSubmit={handleSubmit}>
          <h2 className="styled-text" onClick={() => setIsExpanded(!isExpanded)}>
            Search by Make/Machine/Model
            <span className='chevron-icon'>{isExpanded ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
            </span> 
          </h2>
          {isExpanded && (
            <div className="mmm-widget-container">
              <MakeContainer onChange={handleMakeChange} selectedMake={selectedMake}/>
              <MachineContainer onChange={handleMachineChange}selectedMachine={selectedMachine} selectedMake={selectedMake}/>
              <ModelContainer onChange={handleModelChange} selectedModel={selectedModel} selectedMake={selectedMake} selectedMachine={selectedMachine}/>
              <Button className="button--small"type="submit">Go</Button>        
            </div>
          )}
        </StyledContainer>
        </div>
      </QueryClientProvider>
  );
}

const StyledContainer = styled.form`
  display: flex;
  gap:40px;
  align-items: center;
  flex-direction: column;
  background-color: var(--color--black);
  padding:24px 10px;
  

  .styled-text {
    color: var(--color--white);
    text-align: center;
    font-size: 20px;
    white-space: nowrap;
  }

  .button--small{
    width:100%;
  }

  .chevron-icon{
    margin-left:20px;
  }

  .mmm-widget-container{
    display: flex;
    flex-direction: column;
    gap:20px;
    width:100%;
  }

  .mmm-widget-container .mmm-dropdown{
   &>*{
    flex:1;
   }
  }
  

  @media (min-width: 1025px) {
    flex-direction: row;
    padding:8px 0;

    .button--small{
      width:auto;
    }

    .styled-text{
    margin-bottom:0;
    white-space: nowrap;
    }
    .chevron-icon{
      display:none;
    
    }
    .mmm-widget-container{
    flex-direction: row; 
    align-items: center;
    width:100%;
    }
  }  
`;


function MakeContainer({ onChange,selectedMake}) {
  const { data:makes=[]} = useQuery({
    queryKey: ['makes'],
    queryFn:async()=>{
      const res=await fetchFromAPI(`/machine-make-model/makes`)
      return res.data
     }
  });
  return(<ComboBox placeholder="Select Make" items={makes} onChange={onChange} value={selectedMake} className="mmm-dropdown" /> )
}

function MachineContainer({ onChange, selectedMake,selectedMachine }) {
  const { data:machines=[]} = useQuery({
    queryKey: ['machines', selectedMake],
     queryFn:async()=>{
      const res=await fetchFromAPI(`/machine-make-model/machines?make=${selectedMake}`)
      return res.data
     },
     enabled: !!selectedMake,
    });
  return ( <ComboBox placeholder="Select Machine" items={machines} onChange={onChange} value={selectedMachine} disabled={!selectedMake} className="mmm-dropdown" /> );
}

function ModelContainer({ onChange, selectedMake, selectedMachine,selectedModel}) {
  const { data:models=[]} = useQuery({
    queryKey: ['models', selectedMake, selectedMachine],
    queryFn:async()=>{
      const res=await fetchFromAPI(`/machine-make-model/models?make=${selectedMake}&machine=${selectedMachine}`)
      return res.data
     },
     enabled: !!selectedMachine, 
});
  return (<ComboBox placeholder="Select Model" items={models} onChange={onChange} value={selectedModel} disabled={!selectedMachine} className="mmm-dropdown" />)
}